// Canonical option values (stored/emailed in English) with trilingual labels.
export const PROJECT_CATEGORIES = [
  { value: "Interior Design", fr: "Décoration d'intérieur", it: "Interior Design", en: "Interior Design" },
  { value: "Home Staging", fr: "Home Staging", it: "Home Staging", en: "Home Staging" },
  { value: "Renovation & Space Planning", fr: "Rénovation & aménagement", it: "Ristrutturazione & progettazione", en: "Renovation & Space Planning" },
  { value: "Outdoor Design & Terrace", fr: "Terrasses & espaces extérieurs", it: "Outdoor & terrazza", en: "Outdoor Design & Terrace" },
  { value: "Wedding Design", fr: "Wedding Design", it: "Wedding Design", en: "Wedding Design" },
  { value: "Event Design", fr: "Event Design", it: "Event Design", en: "Event Design" },
  { value: "Commercial Design", fr: "Design commercial", it: "Design commerciale", en: "Commercial Design" },
  { value: "3D Visualisation", fr: "Visualisation 3D", it: "Visualizzazione 3D", en: "3D Visualisation" },
  { value: "Design Consultation", fr: "Consultation déco", it: "Consulenza d'arredo", en: "Design Consultation" },
  { value: "Other", fr: "Autre", it: "Altro", en: "Other" },
];

export const BUDGET_RANGES = [
  { value: "I don't know yet", fr: "Je ne sais pas encore", it: "Non lo so ancora", en: "I don't know yet" },
  { value: "Under €2,500", fr: "Moins de 2 500 €", it: "Meno di 2.500 €", en: "Under €2,500" },
  { value: "€2,500 – €5,000", fr: "2 500 – 5 000 €", it: "2.500 – 5.000 €", en: "€2,500 – €5,000" },
  { value: "€5,000 – €10,000", fr: "5 000 – 10 000 €", it: "5.000 – 10.000 €", en: "€5,000 – €10,000" },
  { value: "€10,000 – €20,000", fr: "10 000 – 20 000 €", it: "10.000 – 20.000 €", en: "€10,000 – €20,000" },
  { value: "€20,000 – €50,000", fr: "20 000 – 50 000 €", it: "20.000 – 50.000 €", en: "€20,000 – €50,000" },
  { value: "Above €50,000", fr: "Plus de 50 000 €", it: "Oltre 50.000 €", en: "Above €50,000" },
];

export const START_DATES = [
  { value: "As soon as possible", fr: "Dès que possible", it: "Il prima possibile", en: "As soon as possible" },
  { value: "In 1–3 months", fr: "Dans 1 à 3 mois", it: "Tra 1 e 3 mesi", en: "In 1–3 months" },
  { value: "In 3–6 months", fr: "Dans 3 à 6 mois", it: "Tra 3 e 6 mesi", en: "In 3–6 months" },
  { value: "In more than 6 months", fr: "Dans plus de 6 mois", it: "Tra più di 6 mesi", en: "In more than 6 months" },
  { value: "Flexible", fr: "Flexible", it: "Flessibile", en: "Flexible" },
  { value: "I'm not sure yet", fr: "Je ne sais pas encore", it: "Non sono ancora sicuro/a", en: "I'm not sure yet" },
];

export const labelFor = (opt, lang) => opt[lang] || opt.en;
